import { gql, useApolloClient, useLazyQuery, useQuery, } from '@apollo/client';
import { DOCUMENTAL_VALIDATION_FIELDS } from '../fragments';
export const DOCUMENTAL_VALIDATION_RELATED_READ = gql `
  ${DOCUMENTAL_VALIDATION_FIELDS}
  query documentalValidationReadByRelated($relatedObjectTypeId: Int, $relatedId: Long) {
    documentalValidation_read_byRelated(relatedObjectTypeId: $relatedObjectTypeId, relatedId: $relatedId) {
      ...DocumentalValidationFields
    }
  }
`;
/**
 * @deprecated -> Se esta sobrescribiendo
 */
export const useDocumentalValidationRelatedReadLazyQuery = (options) => {
    return useLazyQuery(DOCUMENTAL_VALIDATION_RELATED_READ, Object.assign({ errorPolicy: 'all' }, options));
};
/**
 * @deprecated -> Se esta sobrescribiendo
 */
export const useDocumentalValidationRelatedReadQuery = (options) => {
    return useQuery(DOCUMENTAL_VALIDATION_RELATED_READ, Object.assign({ errorPolicy: 'all' }, options));
};
/**
 * @deprecated -> Se esta sobrescribiendo
 */
export const useDocumentalValidationRelatedReadQueryPromise = () => {
    const client = useApolloClient();
    return (variables, options) => client.query(Object.assign(Object.assign({ errorPolicy: 'all' }, options), { query: DOCUMENTAL_VALIDATION_RELATED_READ, variables }));
};
